import React from 'react'
import { Container, Grid } from '@material-ui/core';
import { ButtonHLPure, GridSelectionHLPure, InputHLPure } from '../../pures';
import moment from 'moment';
import { orderBy } from '@progress/kendo-data-query';
import { convertToStandarDate } from '../../../utils';
import { LocalStorageService } from '../../../services';

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t("alertReminders.grid.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>;
};

const CellColumnOne = (props) => {
  const { dataItem } = props;

  let localStorageService = new LocalStorageService()
  let language = localStorageService.getLocalStorageItem("preferredLanguage")
  let date = convertToStandarDate(dataItem.alertDate, language)

  return (
    <td>
      <div>
        <p className='grid-cell-titles-margin-left'>{date}</p>
      </div>
    </td>
  )
}

const CellStatus = (props) => {
  const { dataItem, t } = props;

  let status = dataItem.sent ? t("alertReminders.status.send") : t("alertReminders.status.scheduled")

  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{status}</p>
      </div>
    </td>
  )
}

const AlertReminders = (props) => {
  const {
    alert,
    onBack,
    t
  } = props;

  const sort = [
    {
      field: "alertDate",
      dir: "asc",
    },
  ];

  const data = orderBy(alert.alerts, sort);
  const PAGE_SIZE = 4
  let skip = 0
  const lastSent = data.findLastIndex(a => a.sent)
  if (lastSent !== -1) {
    skip = Math.floor(lastSent / PAGE_SIZE) * PAGE_SIZE
  }

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let AlertsColumnStatus = (props) => <CellStatus {...props} t={t} />

  return (
    <Container maxWidth={"md"} disableGutters>
      <Grid container spacing={3} className='alertDetails'>
        <Grid item xs={12}>
          <InputHLPure
            readOnlyText={alert.emailList.values ? alert.emailList.values.join(", ") : ""}
            labelInput={t('alertDetails.recipients')}
            typeInput="text"
            tooltipShow
            informationIcon
            positionTooltip={'top'}
            titleTooltip={t('alertDetails.recipients')}
            descriptionTooltip={t('alertDetails.errors.separe.emails')}
          />
        </Grid>
        <Grid item xs={12}>
          <InputHLPure
            readOnlyText={alert.name}
            labelInput={t("alertReminders.name.alert")}
            typeInput="text"
          />
        </Grid>
        <Grid item xs={12}>
          <InputHLPure
            readOnlyText={alert.description}
            labelInput={t("alertReminders.description")}
            typeInput="text"
          />
        </Grid>
        <Grid item xs={12}>
          <GridSelectionHLPure
            skip={skip}
            take={PAGE_SIZE}
            pageable={true}
            dataGrid={data}

            titleRow1={t("alertReminders.grid.title.1")}
            headerColumnOne={AllHeadersColumns}
            cellColumnOne={CellColumnOne}

            statusColumn
            titleStatusColumn={t("alertReminders.grid.title.2")}
            headerColumnStatus={AllHeadersColumns}
            cellColumnStatus={AlertsColumnStatus}
          />
        </Grid>

        <Grid container item xs={12} justify='flex-end'>
          <ButtonHLPure
            nameBtn={t("button.return")}
            onClickBtn={onBack}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default AlertReminders